<app-modal [title]="isEditing ? 'Editar contrato' : 'Registrar nuevo contrato'">
    <app-form [formGroup]="saveForm">
      <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
        <div>
          <app-label for="fecha_inicio">
            Fecha de Inicio
          </app-label>
          <app-input-field id="fecha_inicio" type="date" formControlName="fecha_inicio" />
        </div>

        <div>
          <app-label for="fecha_fin">
            Fecha de Fin
          </app-label>
          <app-input-field id="fecha_fin" type="date" formControlName="fecha_fin" />
        </div>

        @if (saveForm.hasError('dateOrder')) {
          <p class="md:col-span-2 text-sm text-error-500">
            La fecha de fin debe ser igual o posterior a la fecha de inicio.
          </p>
        }

        <div class="md:col-span-2">
          <app-label for="documento">Documento del contrato</app-label>
          <app-file-input
            id="documento"
            formControlName="documento"
            (fileChange)="onFileChange($event)"
          />

          @if (documentoActual) {
            <div class="mt-3 flex items-center justify-between rounded-lg border border-gray-200 px-3 py-2 dark:border-gray-700">
              <span class="flex min-w-0 items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <mat-icon class="text-gray-400">description</mat-icon>
                <span class="truncate">{{ documentoActual.nombre }}</span>
              </span>
              <button
                type="button"
                class="ml-3 shrink-0 text-sm text-error-500 hover:text-error-700"
                (click)="removeExistingDocument()"
              >
                Quitar documento
              </button>
            </div>
          }
        </div>

        <div>
          <app-label for="nro_contrato">
            Número de Contrato
          </app-label>
          <app-input-field id="nro_contrato" type="text" formControlName="nro_contrato" placeholder="Ej: CONT-2024-001" />
        </div>

        <div>
          <app-label for="cli_establecimiento_id">
            Establecimiento
          </app-label>
          <app-select id="cli_establecimiento_id" formControlName="cli_establecimiento_id" placeholder="Sin establecimiento específico" [options]="establecimientosOptions" />
        </div>

        <div class="md:col-span-2">
          <app-label for="descripcion">
            Descripción
          </app-label>
          <app-textarea id="descripcion" formControlName="descripcion" [rows]="3" />
        </div>

        @if (isEditing) {
          <div class="md:col-span-2">
            <app-checkbox formControlName="activo" label="Contrato activo" />
          </div>
        }
      </div>
    </app-form>

    <app-creation-buttons *hasPermission="'clientes:create'"
      [valid]="saveForm.valid"
      [process]="loading"
      (onCreateClick)="save()"
      (onCancelClick)="cancel()"
    />
</app-modal>
